// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"588a70b7","420":"817f41a6","493":"e4206d01","532":"f84e6939","977":"dca86f41","986":"35586b6f"}[chunkId] + ".chunk.css";
};